<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-05-25 11:20:50
 * @LastEditors: sueRimn
 * @LastEditTime: 2022-07-27 17:24:30
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\SystemSettings\newsSetting.vue
-->
<template>
  <el-container class="examine">
    <div class="headerCom" style="margin-bottom:0">
      <publicBreadCrumb :breadList="breadList" />
      <publicExpandSearch padBottom='0px' :searchList='searchList' :searchEnd='searchEnd'
        :rightEventList="rightEventList" @rightFunc='rightFunc' v-on:getSearchObj='getSearchObj'></publicExpandSearch>
      <el-tabs v-model="activeTabsName" @tab-click="tabchange" v-if="userPlatForm == 'organization'">
        <el-tab-pane label="全部" name="first"></el-tab-pane>
        <el-tab-pane label="资讯素材模板" name="second"></el-tab-pane>
      </el-tabs>
    </div>
    <el-main class="content">
      <div class="content-list">
        <el-scrollbar style="height: 100%; font-size: 12px; width: 100%">
            <el-table id="tableInfo" :data="tableData" style="width: 100%">
              <el-table-column type="index" label="序号" align="center" fixed="left"></el-table-column>
              <el-table-column show-overflow-tooltip prop="title" label="标题" align="center"></el-table-column>
              <!-- 形式取字段“展示形式” -->
              <el-table-column show-overflow-tooltip prop="type" label="形式" width="100" align="center">
                <template slot-scope="scope">{{ scope.row.type==1?'图文资讯':'纯视频' }}</template>
              </el-table-column>
              <!-- 类型取字段“资讯类型” -->
              <el-table-column show-overflow-tooltip prop="category" label="类型" width="80" align="center">
                <template slot-scope="scope">{{ translateCategory(scope.row.category) }}</template>
              </el-table-column>
              <el-table-column show-overflow-tooltip label="主适配病种" width="110px" align="center" prop="mainDiseaseType">
                <template slot-scope="scope">{{ scope.row.mainDiseaseType }}</template>
              </el-table-column>
              <el-table-column show-overflow-tooltip label="适配病种" align="center" prop="diseaseType">
                <template slot-scope="scope">{{ scope.row.diseaseType }}</template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="labelDatabase" label="标签" align="center"></el-table-column>
              <el-table-column show-overflow-tooltip prop="contentLabelDatabase" label="内容标签"
                align="center"></el-table-column>
              <el-table-column show-overflow-tooltip prop="showTerminal" label="展示端口" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.showTerminal=='DOCTOR'" class="show-port">医生端</span>
                  <span v-else class="show-port show-patient">患者端</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="belongTo" label="归属" align="center"></el-table-column>
              <el-table-column show-overflow-tooltip v-if="activeTabsName == 'first'" prop="status" label="状态"
                width="80" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.status==1" class="no-publish">未发布</span>
                  <span v-else class="yet-publish">已发布</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="createTime" label="创建时间" align="center"></el-table-column>

              <el-table-column v-if="activeTabsName == 'first'" width="240" label="操作" align="center" fixed="right">
                <template slot-scope="scope">
                  <!-- status为0时为已发布状态 -->
                  <el-button @click="openOrClose(scope.row, scope.$index)" type="text" size="small">
                    {{ scope.row.status == 0 ? '下架' : '发布' }}</el-button>
                  <el-button @click="checkDetail(scope.row, scope.$index)" type="text" size="small">详情</el-button>
                  <!-- 只有下架状态才有编辑/删除按钮 -->
                  <el-button @click="updateInformation(scope.row, scope.$index)" type="text" size="small"
                    v-if="scope.row.status == 1">编辑</el-button>
                  <el-button @click="deleteInformationFn(scope.row, scope.$index)" type="text" size="small"
                    v-if="scope.row.status == 1">删除</el-button>
                  <!-- 发布状态时有置顶/取消置顶按钮 -->
                  <!-- <el-button @click="topInformation(scope.row, scope.$index)" type="text" size="small"
                    v-if="scope.row.status == 0">{{ scope.row.seq === 1 ? '取消置顶' : '置顶' }}</el-button> -->
                  <el-popover :ref="scope.$index" placement="left" width="340" popper-class="sort-weight-popper">
                    <div>
                      <el-form label-width="80px" size="mini" label-position="left" class="edit">
                        <el-form-item label="权重占比:">
                          <div class="label-item">
                            <el-input placeholder="请输入1-500整数" v-model.trim="sortWeight" maxlength="3"
                              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                              onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'0')}else{this.value=this.value.replace(/\D/g,'')}">
                            </el-input>
                          </div>
                        </el-form-item>
                        <div class="add-terms-tips">
                          <i style="color:#FAAD14;font-size:16px;" class="el-icon-warning"></i>
                          <div>权重为1-500整数区间，可设定此区间内的权重值，以决定患者端的展示</div>
                        </div>
                      </el-form>
                    </div>
                    <div style="text-align:center; margin: 0">
                      <el-button size="mini" @click="doCloseNew(scope.$index,false)">取消</el-button>
                      <el-button type="primary" size="mini" @click="confimClick(scope.row,scope.$index)">确定</el-button>
                    </div>
                    <!-- v-if="scope.row.status != 0" -->
                    <el-button slot="reference" type="text" style="margin-left:10px;" size="small"
                      @click="referenceClick(scope.row,scope.$index)">配置权重</el-button>
                  </el-popover>
                  <el-button style="margin-left:8px" @click="copyClick(scope.row.id)" type="text" size="small"
                    v-if="scope.row.status == 0 && userPlatForm == 'platForm'">复制URL</el-button>
                </template>
              </el-table-column>
              <el-table-column v-else label="操作" align="center" fixed="right">
                <template slot-scope="scope">
                  <el-button @click="checkDetail(scope.row, scope.$index)" type="text" size="small">详情</el-button>
                  <el-button @click="quote(scope.row, scope.$index)" type="text" size="small">引用</el-button>
                </template>
              </el-table-column>
            </el-table>
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="searchParams.current" :page-size="searchParams.size"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </el-scrollbar>
      </div>
    </el-main>
    <!-- <ExamineDialog ref="examineDialog" :dialogTitle="dialogTitle" /> -->
  </el-container>
</template>

<script>
import local from "@/utils/local.js";
import {
  getInformationPage,
  updateInformationStatus,
  deleteInformation,
  OrQuoteVideo,
  getInformationSetTop,
  findDiseaseTypeByCondition,
  getLabelDatabaseByNameNew,
  sortWeight
} from "./api/index";
import { groupList } from "@/api/Patientmanagement.js";
export default {
  components: {
    // ExamineDialog,
  },
  data() {
    return {
      breadList: [{ name: "工具维护" }, { name: "资讯配置" }],
      searchList: [
        {
          label: "资讯标题",
          paramName: "title",
          inputType: "input",
          maxNum: 20
        },
        {
          label: "展示形式",
          paramName: "type",
          inputType: "select",
          optionData: [
            {
              label: "图文资讯",
              value: 1
            },
            {
              label: "纯视频",
              value: 2
            }
          ],
          remote: false
        },
        {
          label: "资讯类型",
          paramName: "category",
          inputType: "select",
          optionData: [
            {
              label: "康复",
              value: "recovery"
            },
            {
              label: "科普",
              value: "scientific"
            },
            {
              label: "营养",
              value: "nutrition"
            },
            {
              label: "睡眠心理",
              value: "sleep_psychology"
            }
          ],
          remote: false
        },
        {
          label: "主适配病种",
          paramName: "mainDiseaseType",
          remote: false,
          // inputType: "hospital",
          inputType: "selectDisease",
          optionData: [],
          remote: false
        },
        {
          label: "标签搜索",
          paramName: "labelDatabase",
          remote: false,
          inputType: "label",
          optionData: [],
          remote: false
        },
        {
          label: "资讯状态",
          paramName: "status",
          inputType: "select",
          remote: false,
          optionData: [
            {
              label: "未发布",
              value: 1
            },
            {
              label: "已发布",
              value: 0
            }
          ]
        },
        {
          label: "内容标签",
          paramName: "contentLabelDatabase",
          remote: false,
          inputType: "labelTag",
          optionData: [],
          remote: false
        }
      ],
      rightEventList: [{ eventName: "新增资讯", eventValue: 1 }],
      searchParams: {
        current: 1,
        size: 10
      },
      searchEnd: {},
      dialogCheckVisible: false,
      isShowError: false,
      searchCondition: 1,
      searchConditionList: [
        {
          label: "标题",
          value: 1
        },
        {
          label: "展现形式",
          value: 2
        },
        {
          label: "资讯类型",
          value: 3
        },
        {
          label: "主适配病种",
          value: 4
        },
        {
          label: "标签",
          value: 5
        },
        {
          label: "状态",
          value: 6
        }
      ],

      editObj: {
        editId: ""
      },
      tableData: [],
      mainOptions: [],
      options1: [],
      loading1: false,
      loading: false,
      total: 1,
      userid: "",
      userPlatForm: local.get("userPlatForm"), //平台：platForm 机构：organization  local.get('userPlatForm')
      orgName: local.get("orgName") ? local.get("orgName") : "",
      activeTabsName: "first",
      companyId: local.get("companyId"),
      sortWeight: null
    };
  },
  created() {
    if (this.userPlatForm == "platForm") {
      this.searchList.push({
        label: "资讯端口",
        paramName: "showTerminal",
        inputType: "select",
        optionData: [
          {
            label: "医生端",
            value: "DOCTOR"
          },
          {
            label: "患者端",
            value: "PATIENT"
          }
        ]
      });
    }
    let end = this.$route.params;
    if (end && end.condition) {
      this.searchEnd = end.condition;
      this.searchParams = { ...this.searchParams, ...this.searchEnd };
    }
    this.approvePage();
    this.userid = local.get("userid");
  },
  mounted() {},
  methods: {
    copyClick(id) {
      console.log(process.env);
      let url = process.env.VUE_APP_API_URL + "information.html?id=" + id;
      this.$copyText(url)
        .then(result => {
          this.$message.success("复制成功");
        })
        .catch(err => {});
    },
    quote(row) {
      this.$confirm("是否引用此资讯模板", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        OrQuoteVideo(row.id).then(res => {
          if (res.code == 0) {
            if (res.data) {
              this.$message({
                message: "引用成功",
                type: "success"
              });
            } else {
              this.$message.error("引用失败");
            }
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    tabchange() {
      if (this.activeTabsName == "second") {
        this.searchParams.companyId = this.companyId!='null'?this.companyId:null
        this.searchParams.status = 0;
        this.searchParams.showTerminal = "PATIENT";
      } else {
        this.searchParams.companyId = null;
        this.searchParams.status = null;
      }
      this.approvePage();
    },
    openOrClose(data) {
      this.$confirm(
        `本次操作将${data.status == 1 ? "发布" : "下架"}该资讯`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          setTimeout(() => {
            updateInformationStatus(data.id).then(res => {
              this.$message.success("操作成功");
              this.approvePage();
            });
          }, 1000);
        })
        .catch(() => {});
    },
    deleteInformationFn(data) {
      this.$confirm(`本次操作将删除该资讯`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteInformation(data.id).then(res => {
            this.$message.success("操作成功");
            this.approvePage();
          });
        })
        .catch(() => {});
    },
    goEdit() {
      let obj = {
        id: this.editObj.editId
      };
      this.updateInformation(obj);
    },
    updateInformation(data) {
      local.set("saveCondition", JSON.stringify(this.searchParams));
      this.$router.push({
        path: "/SystemSettings/newsSetting/addNews",
        query: {
          id: data.id,
          check: false
        }
      });
    },
    // 置顶/取消置顶操作
    async topInformation(row) {
      // getInformationSetTop
      let { code, data } = await getInformationSetTop(row.id);
      if (code === 0) {
        // 获取list列表
        this.approvePage();
      }
    },
    checkDetail(data) {
      local.set("saveCondition", JSON.stringify(this.searchParams));
      this.$router.push({
        path: "/SystemSettings/newsSetting/addNews",
        query: {
          id: data.id,
          check: true
        }
      });
    },
    addZixun() {
      // 跳转到新增资讯页面
      this.$router.push({
        path: "/SystemSettings/newsSetting/addNews",
        query: {
          check: false
        }
      });
    },
    resetSearchForm() {
      this.searchParams.current = 1;
      this.searchParams.size = 10;
      this.searchParams.type = "";
      this.searchParams.title = "";
      this.searchParams.status = "";
      this.searchParams.category = "";
      this.searchParams.labelDatabase = "";
      this.searchParams.mainDiseaseType = "";
    },
    searchInfo() {
      if (this.activeTabsName == "second") {
        this.searchParams.status = 0;
      }
      this.searchParams.current = 1;
      this.approvePage();
    },
    handleClick(val) {
      if (val.name == 1) {
        this.searchParams.status = "";
        this.approvePage();
      } else if (val.name == 2) {
        this.searchParams.status = 0;
        this.approvePage();
      } else if (val.name == 3) {
        this.searchParams.status = 1;
        this.approvePage();
      } else if (val.name == 4) {
        this.searchParams.status = 2;
        this.approvePage();
      }
    },
    approvePage() {
      getInformationPage({
        ...this.searchParams
      }).then(res => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
    },
    toExamine(row) {
      this.$refs.examineDialog.openDialog(row.id);
      this.dialogTitle = row.name;
    },
    handleCurrentChange(val) {
      this.searchParams.current = val;
      this.approvePage();
    },
    handleSizeChange(val) {
      this.searchParams.size = val;
      this.approvePage();
    },
    videoMainDiseaseParamChange(data) {
      this.searchParams.mainDiseaseType = data;
    },
    remoteMainDiseaseMethod(query) {
      if (query !== "") {
        this.loading = true;
        findDiseaseTypeByCondition(query)
          .then(res => {
            this.loading = false;
            this.mainOptions = res.data;
            this.searchList[3].optionData = res.data.map(item => {
              return {
                ...item,
                value: item.id,
                label: item.suborderName
              };
            });
          })
          .catch(e => {
            this.loading = false;
          });
      } else {
        this.mainOptions = [];
        this.searchList[3].optionData = [];
      }
    },
    videoLabelParamChange(data) {
      this.searchParams.labelDatabase = data;
    },
    translateCategory(category) {
      switch (category) {
        case "recovery":
          return "康复";
          break;
        case "nursing":
          return "护理";
          break;
        case "sport":
          return "运动";
          break;
        case "sleep_psychology":
          return "睡眠心理";
          break;
        case "scientific":
          return "科普";
          break;
        case "nutrition":
          return "营养";
          break;
        default:
          return "-";
      }
    },
    rightFunc(item) {
      if (item.eventValue == 1) {
        // 跳转到新增资讯页面
        this.$router.push({
          path: "/SystemSettings/newsSetting/addNews",
          query: {
            check: false
          }
        });
      }
    },
    getSearchObj(obj) {
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...obj, ...this.searchParams };
      if (this.activeTabsName == "second") {
        this.searchParams.companyId = this.companyId;
        this.searchParams.status = 0;
        this.searchParams.showTerminal = "PATIENT";
      } 
      this.approvePage();
    },
    configurationClick() {
      //配置权重
    },
    doClose(index, flag) {
      if (flag) {
        this.$refs[`group${index}`].doClose();
      } else {
        this.$refs[index].doClose();
      }
    },
    doCloseNew(index, flag) {
      this.$refs[`${index}`].doClose();
    },
    confimClick(item, index) {
      if (this.sortWeight > 500) {
        this.$message.error("配置权重不可超过500");
      } else {
        sortWeight({
          sortWeight: this.sortWeight,
          id: item.id
        }).then(res => {
          if (res.code == 0) {
            this.approvePage();
            this.$message.success("权重配置成功");
          }
        });
        this.$refs[index].doClose();
      }
    },
    referenceClick(item, index) {
      //点击配置权重
      this.sortWeight = item.sortWeight;
    }
  }
};
</script>
<style type="text/css">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.sort-weight-popper {
  padding: 24px;
}
</style>
<style lang="less" scoped>
.no-publish {
  display: inline-block;
  width: 52px;
  height: 24px;
  background: #ffecdb;
  border-radius: 2px;
}
.show-port {
  width: 52px;
  display: inline-block;
  background: #6391f8;
  border-radius: 2px;
  color: #fff;
  text-align: center;
  line-height: 24px;
}
.show-patient {
  background: #3cc5b2;
}
.yet-publish {
  display: inline-block;
  width: 52px;
  height: 24px;
  background: #d6f1ff;
  border-radius: 2px;
}
.add-terms-tips {
  padding: 8px 16px;
  background: #fef8e8;

  font-size: 12px;
  color: #595959;
  margin-bottom: 20px;
  display: flex;
  div {
    flex: 1;
    margin-left: 12px;
  }
}
.avatar-uploader {
  display: inline-block;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.maxHeght {
  height: 60vh;
}
.btn_boxs {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 30px;
  .el-button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}

.avatar {
  width: 60px;
  height: 60px;
  display: block;
}

.add-item-config {
  border: 1px dashed #d9d9d9;
  display: block;
  width: 247px;
}

.text {
  // margin-bottom: 20px;
  color: #333333;
  font-size: 14px;
  line-height: 22px;
  padding-top: 20px;

  span:nth-child(2) {
    color: #333;
  }

  span:nth-child(1) {
    color: #999;
  }
}

.item__error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 0;
}

.add-item-config:hover {
  background: #fcfcfc;
  border: 1px dashed #1a7bfc !important;
}

.add-item-config:focus {
  background: #fcfcfc;
  border: 1px dashed #1a7bfc !important;
}

/deep/.zixun-dialog .el-dialog {
  // max-width: 80%;
  // min-width: 50%;
  width: fit-content;
}

.dialog-content1 {
  display: flex;

  .dialog-content-left {
    margin-right: 100px;
    width: 650px;
    .el-form-item {
      margin-bottom: 30px;
    }
  }
}

.examine {
  height: 100%;
  width: 100%;
  background: #f8f8f8;
  display: flex;
  flex-direction: column;

  .top {
    width: 100%;
    background: #fff;
    padding-left: 25px;
    display: flex;
    flex-direction: column;
    //justify-content: space-between;

    .search {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  .content {
    height: calc(100% - 115px);
    width: 100%;
    padding: 15px;

    .content-list {
      background: #fff;
      border-radius: 5px;
      height: 100%;
      width: 100%;
      padding: 15px;
    }
  }
}

/deep/.el-tabs__header {
  margin: 0;
}

/deep/.el-tabs__nav-wrap::after {
  background: #fff;
}

/deep/.el-tabs__item {
  padding: 0 35px;
}

/deep/.el-scrollbar__wrap {
  overflow-x: hidden;
}

/deep/.el-pagination {
  text-align: right;
  margin-top: 30px;
  margin-right: 30px;
}

/deep/.el-table__header-wrapper {
  background-color: #fafafa;
}

/deep/.el-table th > .cell {
  color: #333;
  font-weight: bold;
}

/deep/.el-table th {
  background: #fafafa;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #1a7bfc;
}
</style>
